<template>
  <div @click="handleClick">
    <a-icon type="appstore" class="mr-2" />
    {{ $t('topBar.myStore') }}
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('user', {
      store_url: state => state.store_url,
    }),
  },
  methods: {
    handleClick () {
      window.open(this.store_url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
